export const Veggie = ['Vegetarian','Vegan','Veg','Veggie'];
export const NonVeggie = ['Non-Vegetarian','Non-Veg','NonVeggie','Non-Vegan'];
